var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTethering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1 7.97c-.62-.62-1.61-.62-2.22 0 -.62.61-.62 1.62 0 2.23 .61.61 1.6.61 2.21 0 .61-.62.61-1.63 0-2.24ZM9.46 6.55c1.39-1.41 3.65-1.41 5.05 0 1.39 1.39 1.39 3.66 0 5.06 -1.4 1.4-3.66 1.4-5.06 0 -1.4-1.4-1.4-3.67 0-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2 5.28c-2.1 2.1-2.1 5.51 0 7.62l-1.42 1.41c-2.88-2.89-2.88-7.56 0-10.45l1.41 1.41Zm7.58 7.62c2.09-2.11 2.09-5.52 0-7.63l1.41-1.42c2.87 2.88 2.87 7.55 0 10.44l-1.42-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63 2.7c-3.52 3.52-3.52 9.25 0 12.78l-1.42 1.41c-4.3-4.31-4.3-11.3 0-15.61l1.41 1.41Zm12.72 12.78c3.51-3.53 3.51-9.26 0-12.79l1.41-1.42c4.29 4.3 4.29 11.29 0 15.6l-1.42-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22V11.67h2v10.32h-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTethering);
export default __webpack_public_path__ + "static/media/tethering.54fa71fe8d0bd8c9d8c8686b2a14fa24.svg";
export { ForwardRef as ReactComponent };